import { useEffect, useState } from 'react';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink } from '../../components/Tab/Tabs';
import { mypageData } from '../../components/Tab/TabData';

import Input from '../../components/TextField/Input';
import { Button } from '../../components/Button/Button';

import Modal, { useToggleModal } from '../../components/Modal/Modal';
import { fetchGet, fetchPut } from '../../hooks/fetch';
import { handlePhone, validateEmail, validatePassword, validatePhone, validateStr } from '../../hooks/useValidate';
import { UserType } from './UserEnum';
import { submitLogout } from '../../hooks/useLogin';
import { openAlert } from '../../components/Modal/MsgBox';
import Loading from '../Loading';

export default function MyInfo() {
	const [isLoading, setIsLoading] = useState(true);
	const [activeTab, setActiveTab] = useState('');

	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};

	const pageName = '내 정보';
	const [info, setInfo] = useState({});
	const [resignInfo, setResignInfo] = useState({});
	const [pwInfo, setPwInfo] = useState({});

	const toggleModal = useToggleModal();

	function getInfo() {
		fetchGet(
			`/mypage/info`,
			(json) => {
				setInfo(json);
				setIsLoading(false);
			}
		)
	}

	useEffect(() => {
		setIsLoading(true);
		getInfo();
	}, []);

	const onChangeInfo = (e) => {
		const { name, value } = e.target;
		setInfo({
			...info,
			[name]: name === 'phone' ? handlePhone(value) : value
		});
	}

	const validateUpdateRequest = (data) => {
		let validate = true;
		if(info?.userType === 'CRIS') {
			validate = validateEmail(data.email);
		} 

		return validatePhone(data.phone) && validate && validateStr(data.company, "소속을") 
			&& validateStr(data.department, "부서명을") && validateStr(data.position, "직책을");
	}

	function update(e) {
		e.preventDefault();

		const request = {
			userType: info.userType,
			phone: info.phone,
			email: info.email,
			company: info.company,
			department: info.department,
			position: info.position
		}

		if(!validateUpdateRequest(request)) return;

		fetchPut(
			`/mypage/info/update`,
			"회원 정보를 수정",
			request
		);
	}

	const onChangeResignInfo = (e) => {
		setResignInfo({
			...resignInfo,
			[e.target.name]: e.target.value
		});
	}

	const validateResignRequest = () => {
		return validateStr(resignInfo.password, "비밀번호를") && validateStr(resignInfo.reason, "탈퇴사유를");
	}

	function resign(e) {
		e.preventDefault();
		if(!validateResignRequest()) return;

		fetchPut(
			`/mypage/info/resign`,
			"회원 탈퇴",
			resignInfo,
			() => {
				toggleModal.close();
				submitLogout();
			}
		);
	}

	function closeResignMd() {
		toggleModal.close();
		setResignInfo({
			password: "",
			reason: ""
		});
	}

	const onChangePwInfo = (e) => {
		setPwInfo({
			...pwInfo,
			[e.target.name]: e.target.value
		})
	}

	const validateChangePwRequest = () => {
		return validateStr(pwInfo.currentPw, "현재 비밀번호를")
			&& validatePassword(pwInfo.newPw, pwInfo.newPwCheck);
	}

	function changePw(e) {
		e.preventDefault();
		if(!validateChangePwRequest()) return;

		fetchPut(
			`/mypage/info/pw`,
			"비밀번호를 재설정",
			pwInfo,
			() => {
				openAlert("비밀번호가 변경되었습니다.", () => {
					toggleModal.close();
				});
			}
		)
	}

	function closePwChangeMd() {
		toggleModal.close();
		setPwInfo({
			currentPw: "",
			newPw: "",
			newPwCheck: ""
		});
	}

	return (
		<main id="mypage-page-wrap">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={mypageData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					{isLoading ? <Loading /> 
						:
						<div className="my-info-page">
							<div className="info-list">
								<Input.Group className="enter-group-row">
									<div className="gs-input">
										<div className="label">회원 종류</div>
										<div className="gs-ipt readonly">{UserType[info.userType]}</div>
									</div>
									<div className="gs-input">
										<div className="label">아이디</div>
										<div className="gs-input-box flex">
											<div className="gs-ipt readonly">{info?.userType === 'CRIS' ? info?.loginId : info?.email}</div>
											{info?.userType === 'GENERAL' &&
												<Button
													type="button"
													className="cyan"
													onClick={() => toggleModal.open({ name: "change-password-modal" })}
												>
													비밀번호 변경
												</Button>
											}
										</div>
									</div>
									<div className="gs-input">
										<div className="label">이름</div>
										<div className="gs-ipt readonly">{info.name}</div>
									</div>
									<Input
										id="user-tel"
										type="tel"
										placeholder="휴대폰 번호를 입력하세요. 예) 010-1234-1234"
										showLabel
										label="휴대폰 번호"
										maxLength={13}
										name="phone"
										value={info.phone}
										onChange={onChangeInfo}
									/>
									{info?.userType === 'CRIS' &&
										<Input
											id="user-email"
											type="email"
											placeholder="이메일을 입력하세요."
											showLabel
											label="이메일"
											name="email"
											value={info.email}
											onChange={onChangeInfo}
										/>
									}
									<Input
										id="affiliation-name"
										type="text"
										placeholder="소속을 입력해주세요."
										showLabel
										label="소속"
										name="company"
										value={info.company}
										onChange={onChangeInfo}
									/>
									<Input
										id="department-name"
										type="text"
										placeholder="부서명을 입력해주세요."
										showLabel
										label="부서명"
										name="department"
										value={info.department}
										onChange={onChangeInfo}
									/>
									<Input
										id="position-name"
										type="text"
										placeholder="직책을 입력해주세요."
										showLabel
										label="직책"
										name="position"
										value={info.position}
										onChange={onChangeInfo}
									/>
								</Input.Group>
							</div>
							<div className="bottom">
								<div className={`gs-flex ${info?.userType === 'GENERAL' ? 'between' : 'flex-end'}`}>
									{info?.userType === 'GENERAL' &&
										<Button
											type="button"
											className="silver"
											onClick={() => toggleModal.open({ name: "membership-withdrawal-modal" }) }
										>
											회원탈퇴
										</Button>
									}
									<Button onClick={update}>수정하기</Button>
								</div>
							</div>
						</div>
					}
				</div>
			</Container>

			{/* 모달 : 회원 탈퇴 */}
			{toggleModal.modal?.name === 'membership-withdrawal-modal' && (
				<Modal
					ariaLabelledby="membership-withdrawal-modal"
					handleOpenModal={closeResignMd}
					style={{ maxWidth: '600px' }}
				>
					<Modal.Header id="membership-withdrawal-modal" className="left">
						회원 탈퇴
					</Modal.Header>
					<Modal.Body>
						<div className="gs-bullet asterisk fc-vivid-red fs-16">
							탈퇴 시 동일 아이디로 재가입 하실 수 없습니다.
						</div>
						<Input.Group className="enter-group-row">
							<Input
								id="user-password"
								type="password"
								placeholder="비밀번호를 입력해주세요."
								showLabel
								label="비밀번호"
								name="password"
								value={resignInfo.password}
								maxLength={20}
								onChange={onChangeResignInfo}
							/>
							<div className="gs-input reason">
								<div className="label">탈퇴사유</div>
								<textarea
									id="withdrawal-reason"
									className="gs-textarea"
									style={{ height: '120px' }}
									placeholder="탈퇴 사유을 입력해 주세요."
									name="reason"
									value={resignInfo.reason}
									maxLength={500}
									onChange={onChangeResignInfo}
								/>
							</div>
						</Input.Group>
					</Modal.Body>
					<Modal.Footer>
						<Button type="button" onClick={resign}><strong>확인</strong></Button>
					</Modal.Footer>
				</Modal>
			)}

			{/* 모달 : 비밀번호 변경 */}
			{toggleModal.modal?.name === 'change-password-modal' && (
				<Modal
					ariaLabelledby="change-password-modal"
					handleOpenModal={closePwChangeMd}
					style={{ maxWidth: '600px' }}
				>
					<Modal.Header id="change-password-modal" className="left">
						비밀번호 변경
					</Modal.Header>
					<Modal.Body>
						<div className="gs-bullet asterisk fc-vivid-red fs-16">
							영문자, 숫자, 특수문자가 포함된 8~16자
						</div>
						<Input.Group className="enter-group-row fb-110">
							<Input
								id="current-password"
								type="password"
								placeholder="현재 비밀번호를 입력해주세요."
								showLabel
								label="현재 비밀번호"
								name="currentPw"
								value={pwInfo.currentPw}
								maxLength={20}
								onChange={onChangePwInfo}
							/>
							<Input
								id="new-password"
								type="password"
								placeholder="새 비밀번호를 입력해주세요."
								showLabel
								label="새 비밀번호"
								name="newPw"
								value={pwInfo.newPw}
								maxLength={20}
								onChange={onChangePwInfo}
							/>
							<Input
								id="re-new-password"
								type="password"
								placeholder="새 비밀번호를 다시 입력해주세요."
								showLabel
								label="새 비밀번호 확인"
								name="newPwCheck"
								value={pwInfo.newPwCheck}
								maxLength={20}
								onChange={onChangePwInfo}
							/>
						</Input.Group>
					</Modal.Body>
					<Modal.Footer>
						<Button onClick={changePw}><strong>확인</strong></Button>
					</Modal.Footer>
				</Modal>
			)}
		</main>
	);
}
